// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__3lXVZ","info":"Panel_info__31C9S","btns":"Panel_btns__3mRve","button":"Panel_button__1H8tl"};